export default __webpack_public_path__ + "static/media/upload-plus-icon.281bd387.svg";